<template>
  <a-modal
    :title="title"
    :visible="visible"
    :width="'60%'"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="loading.confirmLoading"
    :maskClosable="false"
  >
    <template slot="footer" >
      <a-button key="back" @click="handleCancel" :hidden="mode == 'manifest'">
        Cancel
      </a-button>
      <a-button key="submit" type="primary" :loading="loading.save" @click="handleOk" :hidden="mode == 'manifest'">
        Submit
      </a-button>
    </template>
    <loading v-if="loading.modal" />
    <a-form v-else :form="formModal">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-divider orientation="left" style="margin: 0px!important">
            From
          </a-divider>
          <div class="container-essential">
            <a-form-item label="Create Date" hidden>
              <a-date-picker
                placeholder="Select Date"
                :format="getDefaultDateFormat"
                v-decorator="['create_dt', {
                  rules: [{ required: true }],
                  initialValue: (mode!='create' ? data.create_dt : moment())
                }]"
                disabled
              />
            </a-form-item>
            <a-form-item label="SPT Number">
              <a-input
                class="m-width-full m-text-align-right"
                v-decorator="['no', {
                  rules: [{ required: false },],
                  initialValue: data.spt_no
                }]"
                disabled
              />
            </a-form-item>
            <a-form-item label="SPT Type">
              <a-input
                class="m-width-full m-text-align-right"
                v-decorator="['spt_type_label', {
                  rules: [{ required: false },],
                  initialValue: data.spt_type_label
                }]"
                disabled
              />
            </a-form-item>
            <a-form-item label="SPT Periode">
              <a-input
                class="m-width-full m-text-align-right"
                v-decorator="['spt_masa_label', {
                  rules: [{ required: false },],
                  initialValue: data.spt_masa_label
                }]"
                disabled
              />
            </a-form-item>
            <a-form-item label="Value">
              <a-input-number
                :min="0"
                type="number"
                class="m-width-full m-text-align-right"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\Rp\s?|(,*)/g, '')"
                v-decorator="['value', { rules: [{ required: false }, { validator: checkPrice },],
                  initialValue: data.value }]"
                disabled
              />
            </a-form-item>
          </div>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <a-divider orientation="left" style="margin: 0px!important">
              To
            </a-divider>
          <div class="container-essential">
            <a-form-item label="Type Compensation">
              <a-select
                showSearch
                v-decorator="[
                  'kompensasi',
                  {
                    rules: [{ required: true }], initialValue: (mode != 'create' ? data.kompensasi : 'compensation')
                  },
                ]"
                @change="changeCompensation"
                :disabled="true"
              >
              <!-- :disabled="mode == 'manifest'" -->
                <a-select-option value="compensation">Compensation</a-select-option>
                <!-- <a-select-option value="PBK">PBK</a-select-option> -->
              </a-select>
            </a-form-item>
            <a-form-item label="SPT Type">
              <a-select
              v-decorator="['spt_type', { rules: [{ required: true }],
                initialValue: (mode != 'create' ? data.spt_type : data.spt_type_label)  }]"
              class="m-width-full"
              placeholder="Select SPT Type"
              allow-clear
              :disabled="true"
              >
              <!-- :disabled="mode == 'manifest'" -->
                <a-select-option value="ppn">PPN</a-select-option>
                <a-select-option value="pph_21">PPh 21</a-select-option>
                <a-select-option value="pph_unifikasi">PPh Unifikasi</a-select-option>
                <a-select-option value="pph_tahunan">PPh Tahunan</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="SPT Periode">
              <a-month-picker 
                v-decorator="['spt_periode', { rules: [{ required: true }], 
                  initialValue: (mode != 'create' ? moment(data.spt_periode) : undefined)}]"
                :class="getScreen ? 'm-width-full margin-top' : 'm-width-full'"
                placeholder="Select Periode"
                :format="'MM-YYYY'"
                :disabled-date="disabledDate"
                allow-clear
                :disabled="mode == 'manifest'"
                >
              </a-month-picker>
            </a-form-item>
            <a-row :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="Expense Date" v-if="ispbk">
                  <a-date-picker
                    placeholder="Select Date"
                    :format="getDefaultDateFormat"
                    v-decorator="['pbk_dt', {
                      rules: [{ required: true }],
                      initialValue: (mode != 'create' ? moment(data.pbk_dt) : undefined)
                    }]"
                    :disabled="mode == 'manifest'"
                  />
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                <a-form-item label="No. PBK" v-if="ispbk">
                  <a-input
                    v-decorator="['pbk_no', {
                      rules: [{ required: true }],
                      initialValue: (mode != 'create' ? data.pbk_no : undefined)
                    }]"
                      :disabled="mode == 'manifest'"
                  ></a-input>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="Upload PBK Document" v-if="ispbk">
              <a-upload
                  :fileList="fileList"
                  v-decorator="[
                    'file_document_tax',
                    {
                      rules: [{ required: true, validator: doc_validation }],
                      initialValue: (mode != 'create' ? data.file_document_tax : undefined)
                    },
                  ]"
                  :remove="handleRemove"
                  :beforeUpload="beforeUpload"
              >
                  <a-button>
                  <a-icon type="upload" />Select File
                  </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Loading from "@/components/preloader/Loading.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  props: {
    visible: Boolean,
    title: String,
    id_spt: String,
    mode: String,
    data: {},
  },
  mixins: [CurrencyFormat, GlobalMethod],
  components: {
    Loading,
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAuth",
    ]),
  },
  data() {
    let doc_validation = (rule, value, callback) => {
      console.log()
      if (this.fileList && this.fileList == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    return {
      doc_validation,
      loading: {
        modal: false,
        confirmLoading: false,
        save: false,
      },
      fileList: [],
      ispbk: false,
    };
  },
  created() {
    this.formModal = this.$form.createForm(this);
  },
  mounted() {
    if (this.mode == "edit" || this.mode == "manifest") {
      if (this.data.kompensasi == "PBK") {
        this.ispbk = true;
        this.fileList = [];
        this.fileList.push(this.data.file_document_tax[0]);
      }
    }
  },
  watch:{
  },
  methods: {
    moment,
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    disabledDate(current) {
      // Can not select days before today and today
      return this.mode == 'create' ? (current && current < moment(this.data.spt_masa).subtract(0, 'month').endOf('day'))
        : current < moment(this.data.spt_masa).subtract(-1, 'month').endOf('day');
    },
    handleOk() {
      this.formModal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = new FormData();
        data.append("id_spt", this.id_spt);
        data.append("type_kompensasi", values.kompensasi);
        data.append("jenis_spt_masa", values.spt_type);
        data.append("masa_spt", moment(values.spt_periode).format('MM-YYYY'));
        if(this.data.kompensasi_id)
          data.append("kompensasi_id", this.data.kompensasi_id); 

        data.append("date_pbk", moment(values.pbk_dt).format(this.getStandartFormatDate));
        data.append("no_pbk", values.pbk_no);
        data.append("upload_document_file", this.fileList[0]);

        this.loading.confirmLoading = true;
        this.loading.save = true;
        this.asyncAxiosPost( (this.mode=="create" ? "kompensasi" : "kompensasi/edit"), "formdata", this.getAuth, data)
          .then((response) => {
            this.loading.confirmLoading = false;
            this.loading.save = false;
            Event.$emit("closemodal", false);
            Event.$emit("reload", true);
            this.displayMessageValue("success-other", response.message);
          })
          .catch((err) => {
            this.loading.confirmLoading = false;
            this.loading.save = false;
            console.log(err)
            let responses = Object.assign({}, err.response.data);
            if (responses.message && responses.status == false) {
              this.displayMessageValue("error-other", responses.message);
            } else {
              this.displayMessageValue("error", responses);
            }
          });
      });
    },
    handleCancel() {
      Event.$emit("closemodal", false);
    },
    changeCompensation(val) {
      if (val == "PBK") {
        this.fileList = [];
        this.ispbk = true
      } else {
        this.ispbk = false;
      }
    },
    handleRemove() {
      this.fileList = [];
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.fileList = [];
        this.fileList.push(file);
        return false;
      }
    },
  },
};
</script>

<style>
</style>